import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const CheckSubscriptionDriftMutation = graphql.persisted(
  "CheckSubscriptionDrift",
  graphql(`
    mutation CheckSubscriptionDrift($input: CheckSubscriptionDriftInput!) {
      checkSubscriptionDrift(input: $input) {
        success
        driftDetected
        lastDriftCheckAt
        userErrors { message path }
      }
    }
  `)
);

export { CheckSubscriptionDriftMutation };

export function useCheckSubscriptionDrift() {
  return useMutation(CheckSubscriptionDriftMutation);
}
